module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--6-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("¡Bienvenido, "), _c('strong', [_vm._v(_vm._s(_vm.$user.data.givenName))]), _vm._v("!")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--2-col-tablet mdl-cell--2-col-phone"
  }, [_c('span', {
    staticClass: "mdl-typography--text-right",
    attrs: {
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate()))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9a2d1dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Mantenimiento/Newsfeed/Welcome.vue
// module id = 251
// module chunks = 0